<template>

  <div id="dlnkaap_admin_jury">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="closeMessage()"
    ></dlnkalert>

    <!-- ========== MAIN ========== -->
    <main id="content" role="main" class="bg-light">
      <!-- Breadcrumb Section -->
      <div class="bg-primary" style="background-image: url({$img_dir}components/abstract-shapes-20.svg);">
        <div class="container space-1 space-top-lg-2 space-bottom-lg-3">
          <div class="row d-flex justify-content-between px-3">
            <h2 class="text-white my-auto">Répartition du jury par axe</h2>
          </div>
        </div>
      </div>
      <!-- End Breadcrumb Section -->

      <!-- Content Section -->
      <div class="container space-1 space-top-lg-0 space-bottom-lg-2 mt-lg-n10 mx-auto">
        <div class="row">

          <div class="col-12">
            <!-- Card -->
            <div class="card">
                <div class="card-header d-flex justify-content-between align-items-center py-2
                            flex-column flex-lg-row">
                    <h4 class="card-header-title mb-2 mb-lg-0">
                        <button class="btn btn-link" data-toggle="collapse" data-target="#collapseEnfance" 
                                aria-expanded="true" aria-controls="collapseEnfance">
                        SANTÉ ET PETITE ENFANCE
                        </button>
                    </h4>
                </div>

                <!-- Card -->
                <div id="collapseEnfance" class="collapse show">
                    <div class="card-body card-bordered overflow-hidden m-2">

                        <!-- Table -->
                        <div class="table-responsive">
                            <table class="table table-borderless table-thead-bordered table-nowrap table-align-middle">
                            <thead class="thead-light">
                            <tr>
                                <th>Nom du membre</th>
                                <th>Statut</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody id="body_enfance">
                            <tr>
                                <td class="align-middle">
                                    <div class="input-group">
                                      <div class="input-group-prepend bg-soft-primary">
                                        <span class="input-group-text" id="basic-addon1">Membre</span>
                                      </div>
                                      <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
                                    </div>
                                </td>
                                <td class="align-middle">
                                    <select class="custom-select" id="inputGroupSelect01">
                                        <option selected>Choisissez le statut</option>
                                        <option value="1">One</option>
                                        <option value="2">Two</option>
                                        <option value="3">Three</option>
                                    </select>
                                </td>
                                <td class="align-middle">
                                    <a href="javascript:;" class="btn btn-success btn-sm mr-2" role="button" @click="add_new_jury('enfance', 'body_enfance', $event)">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                            </table>
                        </div>
                        <!-- End Table -->

                        
                    </div>
                </div>
                <!-- End Card -->
            </div>
            <!-- End Card -->
          </div>
        </div>
        <!-- End Row -->
      </div>
      <!-- End Content Section -->
    </main>
    <!-- ========== END MAIN ========== -->

    <!-- ZONE DE TEMPLATE -->
    <tr id="jury_template" class="d-none">
        <td class="align-middle">
            <div class="input-group">
              <div class="input-group-prepend bg-soft-primary">
                <span class="input-group-text" id="basic-addon1">Membre</span>
              </div>
              <input type="text" class="form-control" placeholder="Username" aria-label="Username" aria-describedby="basic-addon1">
            </div>
        </td>
        <td class="align-middle">
            <select class="custom-select" id="inputGroupSelect01">
                <option selected>Choisissez le statut</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
            </select>
        </td>
        <td class="align-middle">
            <a href="javascript:;" class="btn btn-success btn-sm mr-2" role="button">
                <i class="fa fa-plus" aria-hidden="true"></i>
            </a>
        </td>
    </tr>

    <a id="delete_button" href="javascript:;" class=" d-none btn btn-danger btn-sm mr-2" role="button" @click="delete_jury($event)">
                                        <i class="fa fa-times" aria-hidden="true"></i>
    </a>

  </div>

</template>


<script>

export default {
  props: {},
  data: function () {
    return {
      message: "",
      message_type: "",
      
    }
  },
  mounted() {
    
  },

  computed: {},

  watch: {},

  methods: {

    close_message: function () {
      this.message = null;
    },

    add_new_jury: function (axe, content_target, event){
      let clone = document.getElementById("jury_template").cloneNode(true);
      clone.removeAttribute("id");
      clone.classList.remove("d-none");
      document.getElementById(content_target).appendChild(clone);

      clone = document.getElementById("delete_button").cloneNode(true);
      clone.removeAttribute("id");
      clone.classList.remove("d-none");
      console.log(event.target);
      event.target.parentNode.appendChild(clone);
      event.target.remove();
    },

    delete_jury: function(event){
      console.log("delete");
      event.target.parentNode.parentNode.remove();
    },
  }
}

</script>
